/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiPreflightFromJSON, StreemApiPreflightToJSON, } from './';
export function StreemApiTwilioRoomVideoCredentialsFromJSON(json) {
    return StreemApiTwilioRoomVideoCredentialsFromJSONTyped(json, false);
}
export function StreemApiTwilioRoomVideoCredentialsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'token': !exists(json, 'token') ? undefined : json['token'],
        'preflight': !exists(json, 'preflight') ? undefined : StreemApiPreflightFromJSON(json['preflight']),
    };
}
export function StreemApiTwilioRoomVideoCredentialsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'token': value.token,
        'preflight': StreemApiPreflightToJSON(value.preflight),
    };
}
//# sourceMappingURL=StreemApiTwilioRoomVideoCredentials.js.map